const STORAGE_KEY = 'velaPostLoginRedirect';

const isSafeRelativePath = (value) =>
  typeof value === 'string' && value.startsWith('/') && !value.startsWith('//');

export function rememberPostLoginRedirect(path) {
  if (typeof window === 'undefined') return;
  const candidate = path || `${window.location.pathname}${window.location.search}${window.location.hash}`;
  if (isSafeRelativePath(candidate) && candidate !== '/login' && candidate !== '/2fa') {
    sessionStorage.setItem(STORAGE_KEY, candidate);
  }
}

export function consumePostLoginRedirect(role) {
  if (typeof window === 'undefined') return null;
  const candidate = sessionStorage.getItem(STORAGE_KEY);
  if (!isSafeRelativePath(candidate)) {
    sessionStorage.removeItem(STORAGE_KEY);
    return null;
  }

  const normalizedRole = String(role || '').toLowerCase();
  const allowed = /^\/(?:notifications\/open|support\/tickets)\/[^/?#]+(?:[?#]|$)/.test(candidate) || /^\/organization-invite(?:[?#]|$)/.test(candidate) || (normalizedRole !== 'billing' && candidate.startsWith('/portal-invite?')) ||
    (normalizedRole === 'billing'
      ? candidate === '/revenue-cycle' || candidate.startsWith('/revenue-cycle/') || candidate.startsWith('/revenue-cycle?')
      : normalizedRole === 'client'
      ? candidate.startsWith('/client')
      : normalizedRole === 'admin'
        ? candidate.startsWith('/admin') || candidate.startsWith('/midwife') || candidate.startsWith('/charting')
        : candidate.startsWith('/midwife') || candidate.startsWith('/charting') || candidate.startsWith('/revenue-cycle'));

  if (!allowed) {
    sessionStorage.removeItem(STORAGE_KEY);
    return null;
  }
  sessionStorage.removeItem(STORAGE_KEY);
  return candidate;
}
